// extracted by mini-css-extract-plugin
export var dividerLine = "_72-3";
export var itemImage = "_72-9";
export var lightDivider = "_72-4";
export var modalContent = "_72-5";
export var modalContentCompact = "_72-6";
export var productCard = "_72-a";
export var productImage = "_72-b";
export var productImageCompact = "_72-7";
export var productImagePlaceholder = "_72-c";
export var productImagePlaceholderCompact = "_72-8";
export var progressBarBackground = "_72-1";
export var progressBarContainer = "_72-0";
export var progressBarFill = "_72-2";